import { render, staticRenderFns } from "./imagesProduct.vue?vue&type=template&id=9ed13066&scoped=true&"
import script from "./imagesProduct.vue?vue&type=script&lang=js&"
export * from "./imagesProduct.vue?vue&type=script&lang=js&"
import style0 from "./imagesProduct.vue?vue&type=style&index=0&id=9ed13066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed13066",
  null
  
)

export default component.exports